import { fmt } from "@/lib/api";
import { useT } from "@/lib/i18n";

const medal = { 1: "bg-amber-400 text-[#0B132B]", 2: "bg-slate-300 text-[#0B132B]", 3: "bg-orange-400 text-[#0B132B]" };

export const groupSlug = (g) => g.key.toLowerCase().replace(/[^a-z0-9]+/g, "-");

export const ResultsGroup = ({ g, admin, onOpen, judges = [] }) => {
  const { t: tr } = useT();
  const t = (k) => (admin ? { "res.place": "M.", "res.performer": "Zawodnik", "res.total": "Suma", "res.incomplete": "niekompl." }[k] : tr(k));
  const top = Math.max(...g.entries.filter((e) => e.complete).map((e) => e.total), 0);
  return (
  <section className="fly-card overflow-hidden break-inside-avoid" data-testid={`results-group-${groupSlug(g)}`}>
    <div className="px-5 py-4 flex items-end justify-between gap-3 border-b border-white/5 bg-gradient-to-r from-blue-600/15 to-transparent">
      <div>
        <h3 className="font-display text-xl sm:text-2xl font-bold uppercase leading-tight">{g.category}</h3>
        <div className="font-mono text-xs text-blue-300 mt-0.5">{g.age_group} · {g.day}</div>
      </div>
      {admin && <span className="font-mono text-xs text-slate-400 whitespace-nowrap">{g.scored}/{g.entries.length} komplet</span>}
    </div>
    <table className="w-full text-sm">
      <thead className="font-mono text-[10px] uppercase tracking-[0.15em] text-slate-500">
        <tr>
          <th className="p-2 pl-5 text-left w-12">{t("res.place")}</th><th className="p-2 text-left">{t("res.performer")}</th>
          {admin && judges.map((n) => <th key={n} className="p-2 text-center hidden md:table-cell">S{n}</th>)}
          <th className={`p-2 text-center ${admin ? "hidden sm:table-cell" : ""}`}>{admin ? "Odj." : t("res.gap")}</th><th className="p-2 pr-5 text-right">{t("res.total")}</th>
        </tr>
      </thead>
      <tbody>
        {g.entries.map((e) => (
          <tr key={e.id} onClick={() => onOpen?.(e)} data-testid={`result-row-${e.id}`}
            className={`border-t border-white/5 ${onOpen ? "cursor-pointer hover:bg-white/[0.03]" : ""} ${!e.complete ? "opacity-50" : ""}`}>
            <td className="p-2 pl-5">
              {e.place ? <span className={`h-7 w-7 rounded-full inline-flex items-center justify-center font-display font-bold ${medal[e.place] || "bg-white/5 text-slate-300"}`}>{e.place}</span> : <span className="text-[10px] font-mono text-amber-400 leading-tight block">{e.judges_scored}/{e.judges_total}<br />{t("res.incomplete")}</span>}
            </td>
            <td className="p-2"><div className="font-semibold">{e.name}</div><div className="text-xs text-slate-500">{e.school}</div></td>
            {admin && judges.map((n) => <td key={n} className="p-2 text-center font-mono text-xs text-slate-300 hidden md:table-cell">{e.judge_totals[n] != null ? fmt(e.judge_totals[n]) : "—"}</td>)}
            {admin ? <td className="p-2 text-center font-mono text-xs text-red-400 hidden sm:table-cell">{e.penalties ? `−${fmt(e.penalties)}` : ""}</td>
              : <td className="p-2 text-center font-mono text-sm text-amber-300 whitespace-nowrap" data-testid={`result-gap-${e.id}`}>{e.complete && e.place !== 1 ? `−${fmt(top - e.total)} ${t("res.pts")}` : ""}</td>}
            <td className="p-2 pr-5 text-right font-display text-2xl font-bold tabular-nums">{fmt(e.total)}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </section>
  );
};
